import loadable from '@loadable/component';

/* istanbul ignore next */
export const FindStores = loadable(() =>
    import(
        /* webpackChunkName: "CartPageWrapperComponentsLazy" */ 'yoda-site-components/lib/components/FindStores/FindStores'
    )
);

/* istanbul ignore next */
export const SingleClickCheckoutWrapper = loadable(() =>
    import(
        /* webpackChunkName: "CartPageWrapperComponentsLazy" */ '../../../../components/SingleClickCheckoutWrapper/SingleClickCheckoutWrapper'
    )
);

/* istanbul ignore next */
export const ItemFulfillmentsNew = loadable(() =>
    import(
        /* webpackChunkName: "CartPageWrapperComponentsLazy" */ '../../../../components/ItemFulfillmentsNew/ItemFulfillmentsNew'
    )
);
